<template>
  <div class="page-container">
    <!-- 基本信息 -->
    <div class="info-header">
      <div class="info-item">
        <span>日期：</span>
        <span>{{ form.dateTime }}</span>
      </div>
      <div class="info-item">
        <span>销售：</span>
        <span>{{ userInfoBase.sellUserInfo.user_name }}</span>
      </div>
      <div class="info-item">
        <span>区域：</span>
        <span>{{ userInfoBase.sellUserInfo.ext_area }}</span>
      </div>
    </div>

    <!-- 表单内容 -->
    <van-form class="form-container" @submit="onSubmit">
      <!-- 本地会销 -->
      <template v-if="form.canSellType === 'local'">
        <!-- 会销地点 -->
        <div class="form-group">
          <div class="form-row">
            <div class="form-label">
              <span class="required-mark">*</span>
              <span>会销地点</span>
            </div>
            <div class="radio-container">
              <van-field v-model="form.meetingLocation" :rules="[{ required: true, message: '请选择会销地点' }]">
                <template #input>
                  <van-radio-group
                    v-model="form.meetingLocation"
                    direction="horizontal"
                    @change="(val) => handleMeetingChange(val)">
                    <van-radio
                      v-for="i in userInfoBase.meetingLocationList"
                      :key="i.key"
                      :name="i.key"
                      icon-size="16px"
                      checked-color="#1989fa"
                    >{{ i.value }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
          </div>
        </div>
        <!-- 会销地点容量 -->
        <div class="form-group" v-if="form.meetingLocation">
          <div class="form-row">
            <div class="form-label">
              <span class="required-mark">*</span>
              <span>场次</span>
            </div>
            <div class="radio-container">
              <van-field v-model="form.meetingSession" :rules="[{ required: true, message: '请选择场次' }]">
                <template #input>
                  <van-radio-group
                    v-model="form.meetingSession"
                    direction="horizontal">
                    <template v-if="form.meetingLocation === 'xy'">
                      <van-radio name="pm" icon-size="16px" checked-color="#1989fa">下午</van-radio>
                    </template>
                    <template v-else>
                      <van-radio
                        v-for="i in userInfoBase.MeetingSessionList"
                        :key="i.key"
                        :name="i.key"
                        icon-size="16px"
                        checked-color="#1989fa"
                      >{{ i.value }}</van-radio>
                    </template>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
          </div>
        </div>
        <!-- 服务类型 -->
        <div class="form-group">
          <div class="form-row">
            <div class="form-label">
              <span class="required-mark">*</span>
              <span>服务类型(可多选)</span>
            </div>
            <div class="radio-container">
              <van-checkbox-group v-model="form.serviceCategory" direction="horizontal">
                <van-checkbox
                  v-for="i in userInfoBase.ServiceCategoryList"
                  :key="i.key"
                  :name="i.key"
                  shape="square"
                  icon-size="16px"
                  checked-color="#1989fa"
                >{{ i.value }}</van-checkbox>
              </van-checkbox-group>
            </div>
          </div>
        </div>
      </template>
      <!-- 预计到场人数 -->
      <div class="form-group">
        <div class="form-row">
          <div class="form-label">
            <span class="required-mark">*</span>
            <span>预计到场客户数</span>
          </div>
          <van-field
            v-model="form.customersNumber"
            type="digit"
            placeholder="限输入1-2000的正整数"
            input-align="right"
            :rules="[{ required: true, message: '请输入预计到场人数' }]"
          />
        </div>
      </div>

      <!-- 渠道 -->
      <div class="form-group">
        <div class="form-row">
          <div class="form-label">
            <span class="required-mark">*</span>
            <span>渠道</span>
          </div>
          <van-field
            v-model="form.org1.channel"
            is-link
            readonly
            input-align="right"
            placeholder="请选择渠道"
            @click="openPicker('channel')"
            :rules="[{ required: true, message: '请选择渠道' }]"
          />
        </div>
      </div>

      <!-- 二级机构 -->
      <div class="form-group">
        <div class="form-row">
          <div class="form-label">
            <span class="required-mark">*</span>
            <span>二级机构</span>
          </div>
          <van-field
            v-model="form.org2.name"
            is-link
            readonly
            input-align="right"
            placeholder="请选择二级机构"
            @click="openPicker('org2')"
            :disabled="!form.org1.data_key"
            :rules="[{ required: true, message: '请选择二级机构' }]"
          />
        </div>
      </div>

      <!-- 三级机构 -->
      <div class="form-group">
        <div class="form-row">
          <div class="form-label">
            <span class="required-mark">*</span>
            <span>三级机构</span>
          </div>
          <van-field
            v-model="form.org3.name"
            is-link
            readonly
            input-align="right"
            placeholder="请选择三级机构"
            @click="openPicker('org3')"
            :disabled="!form.org2.name"
            :rules="[{ required: true, message: '请选择三级机构' }]"
          />
        </div>
      </div> 
      <!-- 卡类型 -->
      <div class="form-group">
        <div class="form-row">
          <div class="form-label">
            <span class="required-mark">*</span>
            <span>卡类型</span>
          </div>
          <div class="radio-container">
            <van-radio-group
              v-model="form.cardType"
              direction="horizontal"
              @change="(val) => handleCardTypeChange(val)">
              <van-radio
                name="1"
                icon-size="16px"
                checked-color="#1989fa"
              >电子卡</van-radio>
              <van-radio
                v-if="form.canSellType !== 'local'"
                name="0"
                icon-size="16px"
                checked-color="#1989fa"
              >实体卡</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>
      <!-- 收货信息 -->
      <div
        class="form-group"
        v-if="form.cardType === '0'">
        <div class="form-row">
          <div class="form-label">
            <span class="required-mark">*</span>
            <span>收货信息</span>
          </div>
          <van-field
            v-model="form.address"
            type="textarea"
            placeholder="请输入收件人、电话、地址等"
            input-align="right"
            :rules="[{ required: true, message: '请输入收货信息' }]"
            rows="2"
            autosize
          />
        </div>
      </div>

      <!-- 卡信息列表 -->
      <div class="card-list-section">
        <div
          v-for="(card, index) in cardList"
          :key="index"
          class="card-info-container"
        >
          <!-- 卡信息标题 -->
          <div class="card-info-header" v-if="index !== 0">
            <span class="card-title"></span>
            <van-icon
              name="cross"
              class="delete-icon"
              @click="removeCard(index)"
            />
          </div>

          <!-- 卡信息内容区域 -->
          <div class="card-info-content">
            <!-- 卡名称 -->
            <div class="form-group">
              <div class="form-row">
                <div class="form-label">
                  <span class="required-mark">*</span>
                  <span>卡名称</span>
                </div>
                <div class="radio-container">
                  <van-radio-group
                    v-model="card.cardName"
                    direction="horizontal"
                    @change="(val) => handleCardNameChange(val, index)">
                    <van-radio
                      v-for="(i, index) in cardListRadio"
                      :key="index"
                      :name="i.name"
                      icon-size="16px"
                      checked-color="#1989fa"
                    >{{ i.code }}</van-radio>
                  </van-radio-group>
                </div>
              </div>
            </div>
            <!-- 卡数量 -->
            <div class="form-group">
              <div class="form-row">
                <div class="form-label">
                  <span class="required-mark">*</span>
                  <span>卡数量</span>
                </div>
                <van-field
                  v-model="card.cardNum"
                  type="digit"
                  placeholder="限输入1-500的正整数"
                  input-align="right"
                  :rules="[{ required: true, message: '请输入卡数量' }]"
                />
              </div>
            </div>
            <!-- 单个卡的金额信息 -->
            <div class="form-group no-border">
              <div class="price-info">
                <div class="price-item">
                  <span class="label">渠道单价</span>
                  <span class="value">{{ getCardPrice(card) }}</span>
                </div>
                <div class="price-item">
                  <span class="label">总价</span>
                  <span class="value">{{ getCardTotalPrice(card) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 添加卡按钮 -->
        <div
          class="add-card-button"
          @click="addCard"
        >
          <van-icon name="plus" />
          <span>增加其他卡</span>
        </div>
      </div>

      <!-- 提交按钮 -->
      <div class="submit-button">
        <el-button
          :loading="btnLoading"
          round
          type="primary"
          native-type="submit"
          class="submit-btn"
        >
          提交
        </el-button>
      </div>
    </van-form>

    <!-- 选择器弹框 -->
    <van-popup
      v-model="showPicker"
      position="bottom"
      round
      safe-area-inset-bottom
    >
      <div class="picker-container">
        <div class="picker-header">
          <div class="picker-title">
            <span @click="showPicker = false">取消</span>
            {{ pickerTitle }}
            <span
              class="confirm"
              @click="onPickerConfirm"
            >确认</span>
          </div>

        </div>
        <div class="search-bar" v-if="pickerType !== 'org3'">
          <van-search
            v-model="searchKey"
            placeholder="请输入搜索关键词"
            shape="round"
            show-action>
            <template #action>
              <div @click="onClickButton">搜索</div>
            </template>
          </van-search>
        </div>
        <van-picker
          :default-index="pickerValue"
          ref="picker"
          :value-key="valueKey"
          :show-toolbar="false"
          :columns="columns"
        />
      </div>
    </van-popup>
    <!-- 页面loading -->
    <van-overlay
      :show="pageLoading"
      z-index="9999">
      <div class="page-loading">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from "vant";
import getUserInfo from "@/models/userInfo";
import offsiteService from "@/apis/offsite/index.js";
import * as dd from "dingtalk-jsapi";

export default {
  name: "OffsiteAdd",
  data() {
    return {
      currentUserInfo: {},
      userInfoBase: {
        sellUserInfo: {}
      },
      // 产品列表
      cardListRadio: [],
      productList: [],
      localProductList: [],
      showPicker: false,
      // 渠道价格数据
      productChannelPriceList: [],
      priceList: [],
      // 渠道数据
      channelList: [],
      // picker数据
      columns: [],
      valueKey: "",
      pickerValue: "",
      pickerType: "", // channel, org2, org3
      searchKey: "",
      form: {
        canSellType: "",
        meetingLocation: "",
        meetingSession: "",
        serviceCategory: [],
        cardType: "1",
        address: "",
        customersNumber: "",
        org1: {},
        org2: {},
        org3: {},
      },
      btnLoading: false,
      // 卡信息列表
      cardList: [
        {
          cardName: "UCAD",
          cardNum: "",
        },
      ],
      pageLoading: false
    };
  },
  computed: {
    // 选择器标题
    pickerTitle() {
      const titles = {
        channel: "选择渠道",
        org2: "选择二级机构",
        org3: "选择三级机构",
      };
      return titles[this.pickerType] || "";
    },
  },
  watch: {
    // 监听弹框显示状态，重置搜索关键词
    showPicker(val) {
      if (!val) {
        this.searchKey = "";
        this.pickerType = "";
      }
    },
  },
  async created() {
    dd.biz.navigation.setTitle({
      title: `新增预约-${this.$route.query.canSellType === 'local' ? '本地会销' : '异地会销'}`, //控制标题文本，空字符串表示显示默认文本
    });
    this.form.dateTime = this.$route.query.date
    this.form.canSellType = this.$route.query.canSellType
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    this.getUser()
  },
  methods: {
    getUser() {
      this.pageLoading = true
      offsiteService.getUserApi(this.currentUserInfo.user_id).then((res) => {
        this.userInfoBase = res.data
        this.productList = res.data.productList
        this.localProductList = res.data.localProductList
        this.channelList = res.data.channelList
        this.productChannelPriceList = res.data.productChannelPriceList
        if (this.form.canSellType === 'remote') {
          this.cardListRadio = this.productList
          this.cardList[0].cardName = res.data?.productList[0].name
        } else {
          this.cardListRadio = this.localProductList
          this.cardList[0].cardName = res.data?.localProductList[0].name
        }
      }).finally(() => {
        this.pageLoading = false
      })
    },
    getChannelList() {
      this.columns = this.channelList
      const index = this.channelList.findIndex(i => i.data_key === this.form.org1.data_key)
      this.pickerValue = index || 0
    },
    getChannelSecondList() {
      offsiteService.getChannelSecondListApi({name: this.searchKey, key: this.form.org1.data_key}).then((res) => {
        this.columns = res.data
        const index = res.data.findIndex(i => i.id === this.form.org2.id)
        this.pickerValue = index || 0
      })
    },
    getChannelThreeList() {
      offsiteService.getChannelThreeListApi(this.form.org2.name).then((res) => {
        this.columns = res.data
        const index = res.data.findIndex(i => i.id === this.form.org3.id)
        this.pickerValue = index || 0
      })
    },
    // 打开选择器
    openPicker(type) {
      this.pickerType = type;
      this.showPicker = true;
      this.searchKey = "";
      this.columns = []
      switch (type) {
        case "channel":
          this.valueKey = 'channel'
          this.getChannelList()
          break;
        case "org2":
          this.valueKey = 'name'
          this.getChannelSecondList()
          break;
        case "org3":
          this.valueKey = 'name'
          this.getChannelThreeList()
          break;
        default:
          break;
      }
    },
    // 选择器搜索
    onClickButton() {
      switch (this.pickerType) {
        case "channel":
          this.columns = this.channelList.filter((item) => item.channel.includes(this.searchKey));
          break;
        case "org2":
          this.getChannelSecondList()
          break;
        case "org3":
          this.getChannelThreeList()
          break;
        default:
          break;
      }
    },
    // 选择器确认
    onPickerConfirm() {
      const value = this.$refs.picker.getValues()[0];
      switch (this.pickerType) {
        case "channel":
          this.form.org1 = value;
          this.changePrice(value.channel)
          this.form.org2 = {}; // 清空下级选择
          this.form.org3 = {};
          break;
        case "org2":
          this.form.org2 = value;
          this.form.org3 = {}; // 清空下级选择
          break;
        case "org3":
          this.form.org3 = value;
          break;
      }
      this.showPicker = false;
    },
    // 价格
    changePrice(val) {
      this.priceList = this.productChannelPriceList.filter((i) => i.level1 === val)
    },
    // 添加新卡
    addCard() {
      this.cardList.push({
        id: this.form.canSellType === 'remote' ? this.productList[0].id : this.localProductList[0].id,
        cardName: this.form.canSellType === 'remote' ? this.productList[0].name : this.localProductList[0].name,
        cardNum: "",
      });
    },
    // 删除卡
    removeCard(index) {
      if (this.cardList.length > 1) {
        this.cardList.splice(index, 1);
      }
    },
    handleMeetingChange(val) {
      if (val === 'xy') {
        this.form.meetingSession = 'pm'
      } else {
        this.form.meetingSession = ''
      }
    },
    // 处理卡类型变化
    handleCardTypeChange(value) {
      if (this.form.canSellType === "remote") {
        if (value === "0") {
          this.cardListRadio = [this.productList[0]];
        } else {
          this.cardListRadio = this.productList
        }
      } else {
        this.cardListRadio = this.localProductList
      }
    },
    handleCardNameChange(value, index) {
      let obj
      if (this.form.canSellType === "local") {
        obj = this.localProductList.find(i => i.name === value)
      } else {
        obj = this.productList.find(i => i.name === value)
      }
      this.cardList[index].id = obj.id
      this.$forceUpdate()
    },
    // 获取单个卡的单价
    getCardPrice(card) {
      const unitPrice = this.priceList?.find(i => i.product_id === card.id)?.price
      let priceList
      if (this.form.canSellType === 'remote') {
        priceList = this.userInfoBase?.productList?.find(i => i.name === card.cardName)?.price
      } else {
        priceList = this.userInfoBase?.localProductList?.find(i => i.name === card.cardName)?.price
      }
      // const unitPricePlus = this.userInfoBase?.productList?.find(i => i.name === card.cardName)?.price
      const price = unitPrice ? parseInt(unitPrice) : priceList ? priceList : 498
      return this.form.org1?.channel ? card.unitPrice = price : '';
    },
    // 获取卡的总价
    getCardTotalPrice(card) {
      const totalPrice = Number(card.cardNum || 0) * this.getCardPrice(card);
      return card.totalPrice = totalPrice;
    },
    onSubmit() {
      if (+this.form.customersNumber > 2000) {
        Toast("预计到场客户数最多不超过2000人!");
        return
      }
      const num = this.cardList.filter(i => +i.cardNum > 500 || +i.cardNum <= 0)
      if (num.length > 0) {
        Toast("单个预约单的总卡数量为1-500!");
        return
      }
      if (this.form.canSellType === 'local' && this.form.serviceCategory.length === 0) {
        Toast("请选择服务类型!");
        return
      }
      this.btnLoading = true
      offsiteService.submitCanSellApi({
        ...this.form,
        region: this.userInfoBase.sellUserInfo.ext_area,
        channel: this.form.org1.channel,
        firstLevelRegion: this.form.org2.name,
        secondLevelRegion: this.form.org3.name,
        listCan: this.cardList,
        personCode: this.userInfoBase.sellUserInfo.user_id,
        personName: this.userInfoBase.sellUserInfo.user_name,
        personPhone: this.userInfoBase.sellUserInfo.user_phone,
        serviceCategory: this.form.serviceCategory.join(",")
      }).then((res) => {
        if (res.code === 200) {
          Toast("提交成功");
          this.$router.back()
        } else {
          Toast(res.message);
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding-bottom: 60px;
  box-sizing: border-box;
  overflow-y: auto;
  background-color: #f7f8fa;
  display: flex;
  flex-direction: column;
  padding-bottom: 70px; // 为底部按钮留出空间
  justify-content: space-between;
}

.info-header {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;

  .info-item {
    font-size: 14px;
    color: #323233;

    span:first-child {
      color: #969799;
    }
  }
}

.form-container {
  flex: 1;
  overflow-y: auto;
  position: relative;

  .form-group {
    background: #fff;
    border-radius: 8px;
    padding: 4px 16px;

    .form-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 44px;
      .form-label {
        flex: 0 0 120px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #323233;

        .required-mark {
          color: #ee0a24;
          margin-right: 4px;
          font-size: 14px;
        }
      }

      .radio-container {
        ::v-deep .van-radio {

          .van-radio__label {
            color: #323233;
            font-size: 14px;
          }
        }
        ::v-deep .van-checkbox {

          .van-checkbox__label {
            color: #323233;
            font-size: 14px;
          }
        }
      }

      ::v-deep .van-field {
        flex: 1;
        padding: 0;
        margin-left: 16px;

        .van-field__control {
          color: #323233;
          font-size: 14px;
          text-align: right;

          &::placeholder {
            color: #c8c9cc;
          }
        }

        .van-field__right-icon {
          margin-right: -8px;
        }
      }
    }
  }
}

.amount-info {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;

  .amount-row {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #323233;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    span:first-child {
      color: #969799;
      margin-right: 8px;
    }

    .add-card-icon {
      margin-left: 8px;
      color: #1989fa;
      font-size: 16px;
      padding: 4px;
      cursor: pointer;

      &:active {
        opacity: 0.7;
      }
    }
  }
}

.submit-button {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  z-index: 99;
  position: fixed;
  bottom: 0;

  .submit-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
    background-color: #001938;
    border-color: #001938;

    &:hover,
    &:focus {
      background-color: #002857;
      border-color: #002857;
    }
  }
}

::v-deep .van-popup {
  border-radius: 16px 16px 0 0;
}

.picker-container {
  .picker-header {
    position: relative;
    padding: 16px;
    text-align: center;
    border-bottom: 1px solid #ebedf0;

    .picker-title {
      font-size: 16px;
      font-weight: 500;
      color: #323233;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .confirm {
        color: #1989fa;
      }
    }

    .picker-actions {
      position: absolute;
      top: 16px;
      right: 16px;
      display: flex;
      align-items: center;
      font-size: 14px;

      span {
        padding: 0 16px;
        color: #969799;
        cursor: pointer;

        &.confirm {
          color: #1989fa;
        }
      }
    }
  }

  .search-bar {
    padding: 0 16px;
    background: #fff;
    border-bottom: 1px solid #ebedf0;
  }
}

.form-group {
  .form-row {
    ::v-deep .van-field {
      &.van-field--textarea {
        .van-field__control {
          min-height: 40px;
          text-align: left;
        }
      }
    }
  }
}

.radio-container {
  ::v-deep .van-radio-group--horizontal {
    justify-content: flex-end;
    .van-radio--horizontal {
      &:last-child {
        margin-right: 0;
      }
    }
  }
  ::v-deep .van-radio {

    .van-radio__label {
      color: #323233;
      font-size: 14px;
    }

    &--disabled {
      .van-radio__label {
        color: #c8c9cc;
      }
    }
  }
}

.card-list-section {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;

  .section-title {
    padding: 16px;
    font-size: 16px;
    font-weight: 500;
    color: #323233;
    border-bottom: 1px solid #f5f5f5;
  }

  .card-info-container {
    position: relative;
    background-color: rgb(238, 241, 249);
    .form-group {
      background: transparent;
      .van-cell {
        background: transparent;
      }
    }

    // &:not(:last-child)::after {
    //   content: "";
    //   position: absolute;
    //   bottom: 0;
    //   left: 16px;
    //   right: 16px;
    //   height: 8px;
    //   background: #f7f8fa;
    // }

    .card-info-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      background: #f7f8fa;

      .card-title {
        font-size: 14px;
        font-weight: 500;
        color: #323233;
      }

      .delete-icon {
        color: #969799;
        font-size: 16px;
        padding: 4px;
        cursor: pointer;

        &:active {
          opacity: 0.7;
        }
      }
    }

    .card-info-content {
      .form-group {
        position: relative;
        padding: 0 16px;

        &:not(:last-child)::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 16px;
          right: 16px;
          height: 1px;
          background: #f5f5f5;
        }

        &.no-border::after {
          display: none;
        }

        .form-row {
          display: flex;
          align-items: center;
          min-height: 44px;

          .form-label {
            flex: 0 0 70px;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #323233;
            margin-right: 12px;

            .required-mark {
              color: #ee0a24;
              margin-right: 4px;
              font-size: 14px;
            }
          }

          .form-value {
            flex: 1;
            text-align: right;
            font-size: 14px;
            color: #323233;
            font-weight: 500;
          }
        }

        .price-info {
          display: flex;
          align-items: center;
          min-height: 44px;
          gap: 32px;

          .price-item {
            display: flex;
            align-items: center;

            .label {
              font-size: 14px;
              color: #969799;
              margin-right: 8px;
            }

            .value {
              font-size: 14px;
              color: #323233;
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  .add-card-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    cursor: pointer;
    transition: background-color 0.2s;
    border-top: 1px solid #f5f5f5;

    &:active {
      background-color: #f2f3f5;
    }

    .van-icon {
      font-size: 16px;
      color: #1989fa;
      margin-right: 4px;
    }

    span {
      font-size: 14px;
      color: #1989fa;
    }
  }
}

.total-amount-info {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;

  .amount-row {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    span:first-child {
      color: #969799;
    }

    span:last-child {
      color: #323233;
      font-weight: 500;
    }
  }
}
</style>
